'use client';
import Nodata from "@/components/shared/no-data/Nodata";
import Image from "next/image";
import {Link} from "@/i18n/routing";
import {useLocale, useTranslations} from 'next-intl';
import {PRIVATE_ROUTE_NAME} from '@/libs/constants/common.constants';
import {useBaseMutation} from '@/libs/api/baseRequests';
import {UPDATE_CLIENT_WISHLIST_SELF_QUERY} from '@/graphql/account';
import {useState} from 'react';
import {useUserContext} from '@/providers/UserContext';
import {useRouter} from '@/i18n/routing';
import {useWishlistContext} from '@/providers/WshlistContext';
import ProductPrice from '@/components/shared/cards/ProductPrice';

export default function HeaderWishlist() {
  const t = useTranslations('wishlist');
  
  const router = useRouter();
  const locale = useLocale();
  
  const {user} = useUserContext();
  const { wishlistProducts, updateWishlist } = useWishlistContext();
  const [submitting, setSubmitting] = useState(false);
  
  const {mutate: mutateWishlist} = useBaseMutation(UPDATE_CLIENT_WISHLIST_SELF_QUERY, {});
  
  const onDeleteProduct = async (product) => {
    if (submitting) return;
    
    if (!user) {
      updateWishlist(product);
      return;
    }
    
    setSubmitting(true);
    const result = await mutateWishlist({
      variables: {
        liked: false,
        productId: product.id
      }
    });
    if (result.data) {
      updateWishlist(product);
    }
    setSubmitting(false);
  }

  return (
    <div
      id="ltn__utilize-wishlist-menu"
      className="ltn__utilize ltn__utilize-cart-menu"
    >
      <div className="ltn__utilize-menu-inner ltn__scrollbar">
        <div className="ltn__utilize-menu-head">
          <span className="ltn__utilize-menu-title">{t('wishlist')}</span>
          <button className="ltn__utilize-close">×</button>
        </div>
        <div className="mini-cart-product-area mini-wishlist-area ltn__scrollbar">
          {!wishlistProducts.length ? (
            <Nodata text={t('wishlistEmpty')} />
          ) : (
              wishlistProducts.map(({ product }, idx) => {
                return (
                    <div key={idx} className="mini-cart-item clearfix">
                      <div className="mini-cart-img">
                        <Link href={`/products/${product.alt}`}>
                          <Image
                              key={product.coverImage}
                              src={product.coverImage}
                              alt={product.title}
                              placeholder="blur"
                              blurDataURL={product.coverImage}
                              width={1000}
                              height={1000}
                              style={{height: 'auto', aspectRatio: 1, objectFit: 'cover'}}
                          />
                        </Link>
                        <span
                            onClick={() => onDeleteProduct(product)}
                            className="mini-cart-item-delete"
                        >
                          <i className="icon-cancel"></i>
                        </span>
                      </div>
                      <div className="mini-cart-info">
                        <h6>
                          <Link href={`/products/${product.alt}`}>
                            {" "}
                            {product.title}
                          </Link>
                        </h6>
                        <ProductPrice
                            price={product.price}
                            clientType={user?.clientType}
                        />
                      </div>
                    </div>
                );
              })
          )}
        </div>
        <div className="mini-cart-footer">
          <div className="btn-wrapper">
            <button
                disabled={submitting}
                className="theme-btn-1 btn btn-effect-1 ltn__utilize-close"
                onClick={() => router.push(user ? { pathname: PRIVATE_ROUTE_NAME, query: { tab: 'wishlist' } } : { pathname: '/wishlist' }, { locale })}
            >
              {t('viewWishlist')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
